<link
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css"
  rel="stylesheet"
/>
<app-accessibility-bar
  class="d-flex flex-column flex-shrink-0 w-100 z-3 position-fixed"
></app-accessibility-bar>
<div class="d-block bg-color">
  <app-sidebar
    class="sidebar d-flex flex-column flex-shrink-0 position-fixed"
    (menuToggled)="toggleSidebar()"
  ></app-sidebar>
  <main class="main-content">
    <section class="dashboard">
      <div class="container-fluid px-0">
        <nav class="navbar navbar-expand-md navbar-light px-0">
          <div class="container-fluid">
            <h2 class="RecyclingPromotion mb-0">
              <div class="d-none d-lg-block">
                {{ user?.organizationName || "N/A" }}
              </div>
            </h2>
            <div class="profile-card d-flex align-items-center">
              <div class="me-3">
                <img
                  src="/assets/images/deepakkumar.svg"
                  alt="User Profile"
                  class="rounded-circle"
                />
              </div>
              <div>
                <p class="mb-0 fw-bold">{{ user?.name || "User" }}</p>
                <small class="text-muted text-capitalize">{{
                  user?.role || "Role"
                }}</small>
              </div>
              <div class="dropdown">
                <button
                  class="btn dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  &nbsp;
                </button>
                <ul class="dropdown-menu dropdown-menu-start">
                  <li>
                    <a class="dropdown-item" (click)="logout()">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_1536_193)">
                          <path
                            d="M14.168 5.83333L12.993 7.00833L15.143 9.16667H6.66797V10.8333H15.143L12.993 12.9833L14.168 14.1667L18.3346 10L14.168 5.83333ZM3.33464 4.16667H10.0013V2.5H3.33464C2.41797 2.5 1.66797 3.25 1.66797 4.16667V15.8333C1.66797 16.75 2.41797 17.5 3.33464 17.5H10.0013V15.8333H3.33464V4.16667Z"
                            fill="#212121"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1536_193">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Logout</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
        <router-outlet></router-outlet>
      </div>
    </section>
  </main>
</div>
